/* eslint-disable no-useless-escape */
export const URL_VALIDATION =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/i;

export const SOCIAL_MEDIA_HANDLE = /@\S+$/i;

export const NAME_VALIDATION = /^[^!@£$%^*(),?;\:_=+~{<}>±§€|\\/0-9]+$/;

export const isErrors = (errors: object) => Object.entries(errors).length > 0;

// removes leading 0 from a formatted phone numbers
export const formatPhoneNumber = (phoneNumber: string, noSpace = false) => {
  const [countryCode, number] = phoneNumber.split(" ");
  const emptyNumber = number === "undefined" || !number;

  if (emptyNumber) return undefined;

  let formattedNumber = number;
  const hasLeadingZero = number.startsWith("0");

  if (hasLeadingZero) formattedNumber = number.substring(1);

  return noSpace
    ? `${countryCode}${formattedNumber}`
    : `${countryCode} ${formattedNumber}`;
};
